import { getBitValueFromHex, generateMissingBits } from '../BitValueCalculator'
import { renderNormalRow } from './NormalRowRenderer'

export const renderCtqByte1Rows = (rows, byteIndex, builderData, currentHexValue, handleCellClick) => {
  const allRows = [];
  const normalRows = rows.filter(row => row.bit !== 0);
  
  const processedRows = generateMissingBits(normalRows, byteIndex, 'ctq', currentHexValue);
  
  for (let bitPos = 8; bitPos >= 1; bitPos--) {
    const row = processedRows.find(r => r.bit === bitPos);
    if (row) {
      const bitValue = getBitValueFromHex(byteIndex, bitPos, currentHexValue, 'ctq');
      
      let updatedMeaning = row.meaning;
      if (byteIndex === 1 && bitPos === 1) {
        updatedMeaning = updateCtqByte1Bit1Meaning(row.meaning, bitValue);
      }
      
      allRows.push(renderNormalRow({
        ...row, 
        value: bitValue,
        meaning: updatedMeaning
      }, byteIndex, true, handleCellClick));
    }
  }
  
  return allRows;
}

const updateCtqByte1Bit1Meaning = (originalMeaning, bitValue) => {
  if (!originalMeaning) return originalMeaning;
  
  const isContactlessAtmPattern = /contactless ATM transactions/i.test(originalMeaning);
  
  if (isContactlessAtmPattern) {
    if (bitValue) {
      if (!originalMeaning.toLowerCase().includes('not')) {
        return originalMeaning.replace(/(valid for contactless ATM transactions)/i, 'Not valid for contactless ATM transactions');
      }
    } else {
      return originalMeaning.replace(/not\s+/i, '');
    }
  }
  
  return originalMeaning;
}
